import axios from "axios"
import Api from "../Apis"
import { useEffect, useState } from "react"
import { AppLoading } from "../Loading"
import { DeletedNav } from "./DeletedNav"

export const ComvertApproved = () => {

    const date = new Date()
    const year = date.getFullYear()
    var month = date.getMonth() + 1
    month = month < 10? `0${month}`:month
    const day = date.getDate()
    // const fromDate = month-1 <1?year-1+"-12-31":day-1<1?year + "-" + month-1 + "-28":`${year}-${month}-${day1}`;
    const [from,setFrom] = useState(`${year}-${month}-${day<10?`0${day}`:day}`)
    const [displayFrom,setDisplayFrom] = useState()
    const [deletedPending,setDeletedPending] = useState([])
    const [autoRefresh,setAutoRefresh] = useState(true)
    const [loading,setLoading] = useState(false)


    const getAllPending = () => {
        setLoading(true)
        axios.get(Api.comvert.value +"/"+from,{headers: Api.Token}).then(res => {
            setDeletedPending(res.data)
            setDisplayFrom(from)
        }).catch((e)=>{
            console.log(e)
            alert("Failed to fetch pendings")
            
        }).finally(() => setLoading(false))
    }
    useEffect(() => {
        getAllPending()
    },[autoRefresh])
    return <>
        <DeletedNav />
        <div className="mt-2">
            <div className="row">
                <h2 className="h3">{displayFrom} pending deletes</h2>
                <div className="col-md-6">
                    <form className="form mb-2 d-flex">
                        <input type="date" className="ms-1 form-control" value={from} onChange={e=>setFrom(e.target.value)}/>
                        
                        <button onClick={(e) => {
                            e.preventDefault()
                            setAutoRefresh(!autoRefresh)
                        }} className="btn btn-primary btn-sm">search</button>
                    </form>
                    
                </div>
            </div>
            <div className="row pb-2">  
            {
                deletedPending && deletedPending.map((res,index) => (
                    
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12 mb-2 " key={index}>
                            <div className="p-2 border border-1 border-dark rounded" style={res.status=="rejected"?
                                {background:"rgb(253, 219, 219)"}:{background:"rgb(216, 233, 248)"}}>

                                <h5>From: {res.from_product.price_in_product.product_name} {res.from_product.price_in_category.category_name} {res.from_product.price_in_type.type_name}</h5>
                                <h5>To: {res.to_product.price_in_product.product_name} {res.to_product.price_in_category.category_name} {res.to_product.price_in_type.type_name}</h5>
                                
                                <p>From Quantity: {res.from_quantity}</p>
                                <p>To Quantity: {res.to_quantity}</p>
                                <p>Amount: {res.amount}</p>
                                <p>Comverted on: {res.date_done}</p>
                                <p>Comverted by: {res.user}</p>
                            </div>

                        </div>
                    
                ))
            }
            </div>
        </div>
        <div style={loading?{display:"block"}:{display:"none"}}>
            <AppLoading />
        </div> 
    </>


}